import { useState } from "react";
import { AdminFormPage } from "./AdminFormPage";

export default {
  title: "CatalogIndex/AdminFormPage",
  component: AdminFormPage,
};

export const EditMode = () => (
  <AdminFormPage
    title='Edit "Gate Approval"'
    formId="example-form"
    onCancel={() => {}}
  >
    <form id="example-form">
      <p>(form fields go here)</p>
    </form>
  </AdminFormPage>
);

export const NewMode = () => (
  <AdminFormPage
    title="Add a Governance"
    formId="example-form"
    onCancel={() => {}}
  >
    <form id="example-form">
      <p>(form fields go here)</p>
    </form>
  </AdminFormPage>
);

export const NewWithSaveAndAddAnother = () => (
  <AdminFormPage
    title="Add a Governance"
    formId="example-form"
    onCancel={() => {}}
    onSaveAndAddAnother={() => {}}
  >
    <form id="example-form">
      <p>(form fields go here)</p>
    </form>
  </AdminFormPage>
);

export const Submitting = () => {
  const [submitting, setSubmitting] = useState(true);
  return (
    <AdminFormPage
      title="Edit Something"
      formId="example-form"
      onCancel={() => setSubmitting(false)}
      isSubmitting={submitting}
    >
      <form id="example-form">
        <p>(submitting state — buttons disabled, spinner showing)</p>
      </form>
    </AdminFormPage>
  );
};
